var exports = {
  "k": "xa9f3555f--31fd73--container",
};

module.exports = exports;
